import { ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { UserService } from "../service/user.service";
import { Log } from "../util/log";
import { Overlay } from '@angular/cdk/overlay';
import { ActivationCode } from "../model/activationCode";
import { DateHelper } from "../util/dateHelper";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { NewUserRequestPermissionType } from "../model/NewUserRequestPermissionType";


@Component({
  selector: 'app-view-request-type-dialog',
  templateUrl: './view-request-type-dialog.component.html',
  styleUrls: ['./view-request-type-dialog.component.css']
})
export class ViewRequestTypeDialogComponent implements OnInit {

  @ViewChild("typesloader", { static: true }) loader;

  wasCreated: boolean = false;

  types: string[] = [];
  items: FormArray = new FormArray([]);
  ownerUid: string;

  name: string = "";

  typeId: string = "";

  nameError: boolean = false;
  typeNameError: boolean = false;

  inputHint = $localize`:@@view_request_type_input_hint:Descrizione del tipo di file da caricare`;

  constructor(
    public dialogRef: MatDialogRef<ViewRequestTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: any,
    public dialog: MatDialog,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private overlay: Overlay
  ) {

    this.ownerUid = this.userService.meUser.uid;

    if (input.data !== null) {
      Log.debug("input.data: ");
      Log.debug(input.data);
      Log.debug("input.data.name: ");
      Log.debug(input.data.name);


      this.types = input.data.fileNames;
      this.name = input.data.name;
      this.typeId = input.data.id;
      this.wasCreated = true;
    }

    if (!this.types || this.types.length === 0) {
      this.types = [""];
    }
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loader.hideLoading();
    }, 100);
  }


  closeDialog() {
    this.dialogRef.close();
  }


  createNewType(): void {
    this.types.push("");
  }

  deleteItem(i: number): void {
    // let message = $localize`:@@view_request_type_delete_filename_confirm}: Conferma eliminazione file richiesto`;
    // let confirmMessage = $localize`:@@view_request_type_delete_filename_confirm_yes}: Conferma`;
    // let cancelMessage = $localize`:@@view_request_type_delete_filename_confirm_no}: Annulla`;

    // const scrollStrategy = this.overlay.scrollStrategies.reposition();

    // const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //   width: "350px",
    //   data: { message, confirmMessage, cancelMessage },
    //   scrollStrategy,
    // });

    // dialogRef.afterClosed().subscribe((response) => {

    //   Log.debug(response);
    //   if (response) {

    //   }
    // });

    //abbiamo optato per un'eliminazione diretta
    this.types.splice(i, 1);
  }


  saveType() {
    Log.debug(this.types);
    Log.debug("saveDetails");


    this.nameError = false;
    this.typeNameError = false;

    if (this.name == "") {
      this.nameError = true;
      return;
    }

    for (let type of this.types) {
      if (type == "") {
        this.typeNameError = true;
        return;
      }
    }

    this.loader.showLoading();

    let newPermissionType = new NewUserRequestPermissionType();
    newPermissionType.name = this.name;
    newPermissionType.fileNames = this.types;


    this.userService.createNewUserRequestPermissionType(this.ownerUid, newPermissionType).subscribe((response) => {
      Log.debug(response);
      setTimeout(() => {
        this.loader.hideLoading();
      }, 100);
      this.dialogRef.close("created");
    }, (err) => {
      Log.debug(err);
      this.loader.showError();
    });
  }

  deleteType(): void {
    let message = $localize`:@@view_request_type_delete_type_confirm: Eliminare la tipologia di permesso?`;
    let confirmMessage = $localize`:@@view_request_type_delete_type_confirm_yes: Conferma`;
    let cancelMessage = $localize`:@@view_request_type_delete_type_confirm_no: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      if (response) {
        this.userService.deleteNewUserRequestPermissionType(this.typeId).subscribe((response) => {
          Log.debug(response);
          this.dialogRef.close("deleted");
        }, (err) => {
          Log.debug(err);
          this.loader.showError();
        });
      }

    });
  }

  // trackBy function to help Angular reuse DOM elements for the list
  // so inputs keep focus while typing.
  trackByIndex(index: number, item: any) {
    return index;
  }


}